import {
  OutgoingContent3t2ohmyam9o76 as OutgoingContent,
  NullBody_instance22vwyocs8eppk as NullBody_instance,
} from '../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import {
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  getKClass3t8tygqu4lcxf as getKClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  toString1pkumu07cwy4m as toString,
  captureStack1fzi4aczwc4hg as captureStack,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { contentType2zzm38yxo3syt as contentType } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMessageProperties.mjs';
import {
  toString30pk9tzaqopn as toString_0,
  arrayOf1akklvh2at202 as arrayOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { trimMarginhyd3fsmh8iev as trimMargin } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Indent.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { get_MaxRetriesPerRequestAttributeKey13gphm9kuo852 as get_MaxRetriesPerRequestAttributeKey } from './HttpRequestRetry.mjs';
import { reversed22y3au42jl32b as reversed } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  orPromise1iucc2to2udt2 as orPromise,
  $3l5vvh8yg0ier as $,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import { Phases_getInstance1dciif7svdqxc as Phases_getInstance } from '../request/HttpRequestPipeline.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { cancel36mj9lv3a0whl as cancel } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from '../call/HttpClientCall.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function HttpSend$Plugin$install$slambda($plugin, $scope) {
  return constructCallableReference(($this$intercept, content, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'kotlin.check' call
    if (!(content instanceof OutgoingContent())) {
      var message = trimMargin('\n|Fail to prepare request body for sending. \n|The body type is: ' + toString(getKClassFromExpression(content)) + ', with Content-Type: ' + toString_0(contentType($this$intercept.w4v_1)) + '.\n|\n|If you expect serialized body, please check that you have installed the corresponding plugin(like `ContentNegotiation`) and set `Content-Type` header.');
      throw IllegalStateException().o(toString(message));
    }
    var tmp0 = $this$intercept.w4v_1;
    // Inline function 'io.ktor.client.request.setBody' call
    var body = content;
    if (body == null) {
      tmp0.k5l_1 = NullBody_instance;
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp = getKClass(OutgoingContent());
      var tmp_0 = null instanceof OutgoingContent();
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_1;
      try {
        tmp_1 = createKType(getKClass(OutgoingContent()), arrayOf([]), false);
      } catch ($p) {
        var tmp_2;
        if ($p instanceof Error) {
          var _unused_var__etf5q3 = $p;
          tmp_2 = null;
        } else {
          throw $p;
        }
        tmp_1 = tmp_2;
      }
      var tmp$ret$4 = tmp_1;
      var tmp$ret$3 = new (TypeInfo())(tmp, tmp_0, tmp$ret$4);
      tmp0.a5p(tmp$ret$3);
    } else {
      if (body instanceof OutgoingContent()) {
        tmp0.k5l_1 = body;
        tmp0.a5p(null);
      } else {
        tmp0.k5l_1 = body;
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp_3 = getKClass(OutgoingContent());
        var tmp_4 = null instanceof OutgoingContent();
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_5;
        try {
          tmp_5 = createKType(getKClass(OutgoingContent()), arrayOf([]), false);
        } catch ($p_0) {
          var tmp_6;
          if ($p_0 instanceof Error) {
            var _unused_var__etf5q3_0 = $p_0;
            tmp_6 = null;
          } else {
            throw $p_0;
          }
          tmp_5 = tmp_6;
        }
        var tmp$ret$6 = tmp_5;
        var tmp$ret$5 = new (TypeInfo())(tmp_3, tmp_4, tmp$ret$6);
        tmp0.a5p(tmp$ret$5);
      }
    }
    var maxRetries = $this$intercept.w4v_1.m5l_1.j4q(get_MaxRetriesPerRequestAttributeKey());
    var tmp_7;
    if (!(maxRetries == null) && maxRetries >= $plugin.e5u_1) {
      var tmp_8;
      if (maxRetries < 2147483647) {
        tmp_8 = maxRetries + 1 | 0;
      } else {
        tmp_8 = maxRetries;
      }
      tmp_7 = tmp_8;
    } else {
      tmp_7 = $plugin.e5u_1;
    }
    var maxSendCount = tmp_7;
    var realSender = new (DefaultSender())(maxSendCount, $scope);
    var interceptedSender = realSender;
    var _iterator__ex2g4s = reversed($plugin.f5u_1).p1();
    while (_iterator__ex2g4s.q1()) {
      var interceptor = _iterator__ex2g4s.r1();
      interceptedSender = new (InterceptedSender())(interceptor, interceptedSender);
    }
    var call = yield* interceptedSender.g5u($this$intercept.w4v_1, $completion);
    yield* $this$intercept.y4u(call, $completion);
    return Unit_instance;
  }), 2);
}
var ConfigClass;
function Config() {
  if (ConfigClass === VOID) {
    class $ {
      constructor() {
        this.h5u_1 = 20;
      }
    }
    initMetadataForClass($, 'Config', Config);
    ConfigClass = $;
  }
  return ConfigClass;
}
var PluginClass;
function Plugin() {
  if (PluginClass === VOID) {
    class $ {
      constructor() {
        Plugin_instance = this;
        var tmp = this;
        // Inline function 'io.ktor.util.AttributeKey' call
        var name = 'HttpSend';
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp_0 = getKClass(HttpSend());
        var tmp_1 = null instanceof HttpSend();
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_2;
        try {
          tmp_2 = createKType(getKClass(HttpSend()), arrayOf([]), false);
        } catch ($p) {
          var tmp_3;
          if ($p instanceof Error) {
            var _unused_var__etf5q3 = $p;
            tmp_3 = null;
          } else {
            throw $p;
          }
          tmp_2 = tmp_3;
        }
        var tmp$ret$2 = tmp_2;
        var tmp$ret$1 = new (TypeInfo())(tmp_0, tmp_1, tmp$ret$2);
        tmp.i5u_1 = new (AttributeKey())(name, tmp$ret$1);
      }
      m3() {
        return this.i5u_1;
      }
      j5u(block) {
        // Inline function 'kotlin.apply' call
        var this_0 = new (Config())();
        block(this_0);
        var config = this_0;
        return new (HttpSend())(config.h5u_1);
      }
      o5l(block) {
        return this.j5u(block);
      }
      k5u(plugin, scope) {
        var tmp = Phases_getInstance().t5p_1;
        scope.n5j_1.a4w(tmp, HttpSend$Plugin$install$slambda(plugin, scope));
      }
      p5l(plugin, scope) {
        return this.k5u(plugin instanceof HttpSend() ? plugin : THROW_CCE(), scope);
      }
    }
    initMetadataForObject($, 'Plugin');
    PluginClass = $;
  }
  return PluginClass;
}
var Plugin_instance;
function Plugin_getInstance() {
  if (Plugin_instance === VOID)
    new (Plugin())();
  return Plugin_instance;
}
var InterceptedSenderClass;
function InterceptedSender() {
  if (InterceptedSenderClass === VOID) {
    class $_0 {
      constructor(interceptor, nextSender) {
        this.l5u_1 = interceptor;
        this.m5u_1 = nextSender;
      }
      *g5u(requestBuilder, $completion) {
        return yield* $(this.l5u_1(this.m5u_1, requestBuilder, $completion), $completion);
      }
    }
    initMetadataForClass($_0, 'InterceptedSender', VOID, VOID, VOID, [1]);
    InterceptedSenderClass = $_0;
  }
  return InterceptedSenderClass;
}
var DefaultSenderClass;
function DefaultSender() {
  if (DefaultSenderClass === VOID) {
    class $ {
      constructor(maxSendCount, client) {
        this.n5u_1 = maxSendCount;
        this.o5u_1 = client;
        this.p5u_1 = 0;
        this.q5u_1 = null;
      }
      *g5u(requestBuilder, $completion) {
        var tmp0_safe_receiver = this.q5u_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          cancel(tmp0_safe_receiver);
        }
        if (this.p5u_1 >= this.n5u_1) {
          throw SendCountExceedException().v5u('Max send count ' + this.n5u_1 + ' exceeded. Consider increasing the property ' + 'maxSendCount if more is required.');
        }
        this.p5u_1 = this.p5u_1 + 1 | 0;
        var sendResult = yield* this.o5u_1.p5j_1.v4v(requestBuilder, requestBuilder.k5l_1, $completion);
        var tmp1_elvis_lhs = sendResult instanceof HttpClientCall() ? sendResult : null;
        var tmp;
        if (tmp1_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'Failed to execute send pipeline. Expected [HttpClientCall], but received ' + toString(sendResult);
          throw IllegalStateException().o(toString(message));
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var call = tmp;
        this.q5u_1 = call;
        return call;
      }
    }
    initMetadataForClass($, 'DefaultSender', VOID, VOID, VOID, [1]);
    DefaultSenderClass = $;
  }
  return DefaultSenderClass;
}
var HttpSendClass;
function HttpSend() {
  if (HttpSendClass === VOID) {
    class $ {
      constructor(maxSendCount) {
        Plugin_getInstance();
        maxSendCount = maxSendCount === VOID ? 20 : maxSendCount;
        this.e5u_1 = maxSendCount;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.f5u_1 = ArrayList().p2();
      }
      w5u(block) {
        // Inline function 'kotlin.collections.plusAssign' call
        this.f5u_1.j2(block);
      }
    }
    initMetadataForClass($, 'HttpSend');
    HttpSendClass = $;
  }
  return HttpSendClass;
}
var SendCountExceedExceptionClass;
function SendCountExceedException() {
  if (SendCountExceedExceptionClass === VOID) {
    class $ extends IllegalStateException() {
      constructor(message) {
        return new.target.v5u(message);
      }
      static v5u(message) {
        var $this = this.o(message);
        captureStack($this, $this.u5u_1);
        return $this;
      }
    }
    initMetadataForClass($, 'SendCountExceedException');
    SendCountExceedExceptionClass = $;
  }
  return SendCountExceedExceptionClass;
}
//region block: exports
export {
  Plugin_getInstance as Plugin_getInstancedvtd2m29fslb,
};
//endregion

//# sourceMappingURL=HttpSend.mjs.map
